import { AppointmentCategory } from "../../types/garage/planning";

// --- Atelier grid drag types ---

export interface JobDragPreview {
  type: "job";
  jobId: string;
  startHour: number;
  durationHours: number;
  workerId: string;
  date?: string;
}

export interface ChargeDragPreview {
  type: "charge";
  chargeId: string;
  startHour: number;
  durationHours: number;
  workerId: string;
  clientName: string;
  date?: string;
}

export type GridPreview = JobDragPreview | ChargeDragPreview;

// --- Atelier grid constants ---

export const HOURS_START = 8;
export const HOURS_END = 20;
export const SNAP_PX = 16;
export const SNAP_HOUR = 0.125;
export const HOUR_BLOCK_HEIGHT = 128;
export const LUNCH_HOUR = 12;
